'use es6';

import * as client from 'DesignData/api/RawAssets';
import { RAW_ASSET_CREATE, RAW_ASSET_PUBLISH, RAW_ASSET_SAVE_BY_PATH, RAW_ASSET_FETCH_HAS_BUFFERED_CHANGES } from 'DesignData/actions/ActionTypes';
import { getHasBufferedChanges, getPublishStatus } from 'DesignData/selectors/rawAssetBuffers';
import { RAW_ASSET } from 'DesignData/enums/FolderAssetTypes';
import { PENDING } from 'DesignData/enums/RequestStatus';

const messageFactory = type => (rawAssetId, fields) => Object.assign({
  type,
  rawAssetId
}, fields);
/**
 * Create a new raw asset
 */


export function create(path, source) {
  const message = fields => Object.assign({
    type: RAW_ASSET_CREATE,
    path,
    fileType: RAW_ASSET
  }, fields);

  return dispatch => {
    dispatch(message({}));
    return client.create({
      path,
      source
    }).then(rawAsset => {
      const fields = {
        path,
        rawAsset
      };
      dispatch(message(fields));
      return fields;
    }).catch(error => {
      const fields = {
        path,
        error
      };
      dispatch(message(fields));
      return fields;
    });
  };
}
const publishMessage = messageFactory(RAW_ASSET_PUBLISH);
/**
 *  Push buffer live
 *
 * @param {number} rawAssetId
 */

export function publish(rawAssetId) {
  return (dispatch, getState) => {
    const state = getState();
    const props = {
      rawAssetId
    };
    const hasBufferedChanges = getHasBufferedChanges(state, props);
    if (!hasBufferedChanges) return;
    const publishStatus = getPublishStatus(state, props);
    if (publishStatus === PENDING) return;
    dispatch(publishMessage(rawAssetId));
    client.publish(rawAssetId).then(rawAsset => {
      dispatch(publishMessage(rawAssetId, {
        rawAsset
      }));
    }).catch(error => {
      dispatch(publishMessage(rawAssetId, {
        error
      }));
    });
  };
}
const stageMessage = messageFactory(RAW_ASSET_SAVE_BY_PATH);
/**
 *  Stage changes that can later be deployed
 *
 * @param {number} rawAssetId
 */

export function stageChanges(rawAssetData) {
  return (dispatch, getState) => {
    const {
      id: rawAssetId,
      path
    } = rawAssetData;
    const state = getState();
    const props = {
      rawAssetId
    };
    const hasBufferedChanges = getHasBufferedChanges(state, props);
    if (!hasBufferedChanges) return;
    const publishStatus = getPublishStatus(state, props);
    if (publishStatus === PENDING) return;
    dispatch(stageMessage(rawAssetId));
    client.saveByPath(path, rawAssetData, {
      staging: true
    }).then(rawAsset => {
      dispatch(stageMessage(rawAssetId, {
        rawAsset,
        rawAssetBeforeUpdate: rawAssetData
      }));
    }).catch(error => {
      dispatch(stageMessage(rawAssetId, {
        error
      }));
    });
  };
}
const fetchHasBufferedChangesMessage = messageFactory(RAW_ASSET_FETCH_HAS_BUFFERED_CHANGES);
/**
 * Determines if asset has buffered changes.
 *
 * @param {number} rawAssetId
 */

export function fetchHasBufferedChanges(rawAssetId) {
  return dispatch => {
    dispatch(fetchHasBufferedChangesMessage(rawAssetId));
    client.hasBufferedChanges(rawAssetId).then(({
      has_changes: hasBufferedChanges
    }) => {
      hasBufferedChanges = !!hasBufferedChanges;
      dispatch(fetchHasBufferedChangesMessage(rawAssetId, {
        hasBufferedChanges
      }));
    }).catch(error => {
      dispatch(fetchHasBufferedChangesMessage(rawAssetId, {
        error
      }));
    });
  };
}
export function fetchHasBufferedChangesByPath(rawAssetId) {
  return dispatch => {
    dispatch(fetchHasBufferedChangesMessage(rawAssetId));
    client.hasBufferedChangesByPath(rawAssetId).then(({
      has_changes: hasBufferedChanges
    }) => {
      hasBufferedChanges = !!hasBufferedChanges;
      dispatch(fetchHasBufferedChangesMessage(rawAssetId, {
        hasBufferedChanges
      }));
    }).catch(error => {
      dispatch(fetchHasBufferedChangesMessage(rawAssetId, {
        error
      }));
    });
  };
}